import { render, staticRenderFns } from "./Sketchpad.vue?vue&type=template&id=d8de75e4&scoped=true"
import script from "./Sketchpad.vue?vue&type=script&lang=js"
export * from "./Sketchpad.vue?vue&type=script&lang=js"
import style0 from "./Sketchpad.vue?vue&type=style&index=0&id=d8de75e4&prod&lang=scss&scoped=true"
import style1 from "./Sketchpad.vue?vue&type=style&index=1&id=d8de75e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8de75e4",
  null
  
)

export default component.exports